
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageSquare, Star } from "lucide-react";

const StartupFeedback = () => {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Star className="h-5 w-5 text-yellow-500" />
            Startup Feedback
          </CardTitle>
          <CardDescription>
            General feedback and suggestions from the startup community are automatically sent to teenvisor@gmail.com
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8 text-muted-foreground">
            <MessageSquare className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p>All feedback submissions are sent directly to teenvisor@gmail.com</p>
            <p className="text-sm">Community feedback is automatically forwarded for review and action</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StartupFeedback;
